import { createAction } from 'redux-actions'
import * as ActionTypes from 'constants/actionType'

const resetWaiterNumberPadAction = createAction(ActionTypes.RESET_WAITER_NUMBER_PAD)
const resetWaiterNumberPadValueAction = createAction(ActionTypes.RESET_WAITER_NUMBER_PAD_VALUE)
const updateDisplayWaiterNumberPadAction = createAction(ActionTypes.UPDATE_DISPLAY_WAITER_NUMBER_PAD)
const updateWaiterNumberPadValueAction = createAction(ActionTypes.UPDATE_WAITER_NUMBER_PAD_VALUE)

export function resetWaiterNumberPad () {
  return (dispatch) => {
    dispatch(resetWaiterNumberPadAction())
  }
}

export function resetWaiterNumberPadValue () {
  return (dispatch) => {
    dispatch(resetWaiterNumberPadValueAction())
  }
}

export function updateDisplayWaiterNumberPad (display) {
  return (dispatch) => {
    dispatch(updateDisplayWaiterNumberPadAction({ display }))
  }
}

export function updateWaiterNumberPadValue (value) {
  return (dispatch) => {
    dispatch(updateWaiterNumberPadValueAction({ value }))
  }
}



// WEBPACK FOOTER //
// ./src/actions/components/waiter.js